import { theme } from '@prophecy/theme';
import { Text } from '@prophecy/ui-v3/Typography';

export default function DeploymentStepHeader({ title }: { title: string }) {
  return (
    <Text level='xl' weight={theme.fontWeight.medium}>
      {title}
    </Text>
  );
}
